import { InformationIcon } from '@strata/react-status-icons';

export const MultiStrengthTooltip = () => (
    <InformationIcon
        tooltipText={
            <>
                <p>
                    This product is available in multiple strengths and more than one variation of
                    the product may be required to optimally fulfill the administered quantity while
                    minimizing product waste.
                </p>
                <p>
                    Billing policies may differ by payer. Please consider individual payer policies
                    when submitting claims for this product.
                </p>
                Depending on payer policy the quantity submitted on the claim may be greater than
                the quantity displayed here to appropriately align with payer policy.
            </>
        }
    />
);
